function checkQuerySessionId() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
    let value = params.id; // "some_value"
    return value;
}

async function fetchOrderDetails(SID) {
    try {
        let resp = await postCheckout({lambdaRoute: "/checkout/session/getOrder", sessionID: SID});
        if (resp?.sessionLookupFailed) {
            
            return;
        }

        let Date_Options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            timeZone: "America/Los_Angeles",
        };
        let subscription = resp?.cb?.subscription;
        let orderViewCount = resp?.orderViewCount;
        let invoice = resp?.invoice;
        let sID = subscription?.id;
        let value = invoice?.total * 0.01;
        let shippingPrice = resp?.shippingPrice;
        let items = resp?.items;
        let invoiceDate = new Intl.DateTimeFormat("en-US", Date_Options).format(invoice?.date * 1000);


        if (orderViewCount === 0) {
            let containsSnack = false;
            items.forEach((lineItem) => {
                let title = String(lineItem?.name).toLowerCase();
                if (title.includes("super not another crap kit") || title.includes("nerdecrafter") || title.includes("secret sale")) {
                    containsSnack = true;
                }
            })
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ecommerce: null}); // Clear the previous ecommerce object.
            dataLayer.push({
                event: "purchase",
                themegtm: true,
                containsSnack,
                ecommerce: {
                    transaction_id: sID,
                    value: value,
                    currency: "USD",
                    tax: 0,
                    shipping: shippingPrice,
                    items: items,
                },
            });
        }
        await postCheckout({lambdaRoute: "/checkout/session/order-view-count-update", sessionID: SID});
        return {subscription, invoice, sID, value, shippingPrice, items, invoiceDate};
    } catch (err) {
        console.log(err);
        return {err};
    }
}

window.addEventListener("DOMContentLoaded", async function () {
    let SID = checkQuerySessionId();
    if (!SID) {
        return;
        
        // showDefaultThankYouPage()
    }
    
    let orderDetails = await fetchOrderDetails(SID);
    let containsCreaturesOfDarkness = false;
    orderDetails.items.every(item => {
        if (item.name.includes("Creatures of Darkness")) {
            containsCreaturesOfDarkness = true;
            return false // to stop iterating
        }
        return true
    })

    if (containsCreaturesOfDarkness) {
        $("#digitalDownloadMessage").show()
        $("#nonDigitalDownloadMessage").hide()
    }
    // $("#order__date").text(`Date: ${orderDetails.invoiceDate}`);
    // $("#order__total").text(`Total: $${orderDetails.value}`);
    // $("#order__shipping").text(`Shipping: $${orderDetails.shippingPrice}`);
    // $("#order__shipping-address").text(`Address: ${orderDetails.invoice.shipping_address}`);

});
